import DrumKit from './drum_kit_1';
// import DrumKit2 from './drum_kit_2';
// import DrumKit3 from './drum_kit_3';
import LeadSynth from './lead_synth_1';
import LeadSynth2 from './lead_synth_2';
// import LeadSynth3 from './lead_synth_3';

export default {
  DrumKit,
  LeadSynth,
  LeadSynth2
}



// WEBPACK FOOTER //
// ./frontend/util/instruments.js